<!--
  创建时间：2023/7/28 14:42
  创建人：toyehuang
  文件描述：NavItem
-->

<template>
  <div
    v-if="
      hasOneShowingChild(item.appColumnRespVOList, item) &&
        (!onlyOneChild.appColumnRespVOList || onlyOneChild.noShowingChildren)
    "
    class="menu-nav-item"
  >
    <app-link
      :to="resolvePath(onlyOneChild.path, onlyOneChild.query)"
      :item="onlyOneChild"
    >
      <el-menu-item
        :index="resolvePath(onlyOneChild.path)"
        :class="{ 'submenu-title-noDropdown': !isNest }"
      >
        <item
          :icon="onlyOneChild.icon || item.icon"
          :title="onlyOneChild.name"
        />
      </el-menu-item>
    </app-link>
  </div>
  <div v-else class="menu-nav-item">
    <el-submenu ref="subMenu" popper-class="my-submenu-pop" :class="{'is-active': activeIndex === resolvePath(item.path)}" :index="resolvePath(item.path)" :popper-append-to-body="false">
      <template #title>
        <item :icon="item.icon" :title="item.name" />
      </template>
      <nav-item
        v-for="child in item.appColumnRespVOList"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        v-bind="$attrs"
        :active-index="activeIndex"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from "path";
import { isExternal } from "@/utils/validate";
import Item from "./Item";
import AppLink from "./Link";
export default {
  name: "NavItem",
  components: { Item, AppLink },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ""
    },
    activeIndex: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      onlyOneChild: null
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
    hasOneShowingChild(appColumnRespVOList = [], parent) {
      if (!appColumnRespVOList) {
        appColumnRespVOList = [];
      }
      const showingChildren = appColumnRespVOList.filter((item) => {
        if (!item.visible) {
          return false;
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item;
          return true;
        }
      });

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true;
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: "", noShowingChildren: true };
        return true;
      }

      return false;
    },
    resolvePath(routePath, routeQuery) {
      if (isExternal(routePath)) {
        return routePath;
      }
      if (isExternal(this.basePath)) {
        return this.basePath;
      }
      if (routeQuery) {
        const query = JSON.parse(routeQuery);
        return { path: path.resolve(this.basePath, routePath), query: query };
      }
      return path.resolve(this.basePath, routePath);
    },
    handleSubmenuClick(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style scoped lang="scss"></style>
